module.exports = __webpack_public_path__ + "img/release_to_wild.717a68bf.svg";